import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/annex-1-diagnostic")({
  head: () => buildRouteHead("/annex-1-diagnostic", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/annex-1-diagnostic", replace: true });
  },
});
